import dashboard from './dashboard'
import subject from './subject'
import reading from './activity'

export default {
  ...dashboard,
  ...subject,
  ...reading,
}
